const springBootApiBaseUrl = process.env.REACT_APP_SPRING_BOOT_API_URL;

/**
 * Release Notification API
 */

/**
 * Subscribe the current user to release notifications for a tool.
 * Returns void; backend responds 204 on success.
 */
export async function subscribeToReleaseNotifications(
    toolCode: string,
    token?: string | null
): Promise<void> {
    const response = await fetch(
        `${springBootApiBaseUrl}/api/notification/request-release-notification/${encodeURIComponent(toolCode)}`,
        {
            method: "POST",
            headers: {
                Authorization: token ? `Bearer ${token}` : "",
            },
        }
    );

    if (!response.ok) {
        throw new Error(`Subscribe failed: ${response.status}`);
    }
}

/**
 * Get tool codes the current user is subscribed to.
 * Returns an array of toolCode strings.
 */
export async function getReleaseNotificationSubscriptions(
    token?: string | null
): Promise<string[]> {
    const response = await fetch(
        `${springBootApiBaseUrl}/api/notification/release-notification-subscriptions`,
        {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        }
    );

    if (!response.ok) {
        throw new Error(`Get subscriptions failed: ${response.status}`);
    }

    return response.json();
}

/**
 * Unsubscribe the current user (from JWT) from release notifications for a tool.
 * Returns void; backend responds 204 on success.
 */
export async function unsubscribeFromReleaseNotifications(
    toolCode: string,
    token?: string | null
): Promise<void> {
    const encodedToolCode = encodeURIComponent(toolCode);

    const response = await fetch(
        `${springBootApiBaseUrl}/api/notification/release-notification-subscriptions/${encodedToolCode}`,
        {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`
            },
        }
    );

    if (!response.ok) {
        throw new Error(`Unsubscribe failed: ${response.status}`);
    }
}